<template>
    <div id="ai-home-start">
        <div id="ai-home-start-widget-container">
            <div id="ai-widget-row">
                <ai-search-form
                    @search="onSearch"
                    @search-start="onSearchStart"
                    @search-end="onSearchEnd"
                    @focusin="onFocusin"
                    @force="onForce"
                />
            </div>
        </div>
        <div v-if="resultsVisible" class="ai-search-panel-container">
            <div class="ai-search-panel">
                <dx-data-grid
                    ref="gridRef"
                    height="100%"
                    class="h-0 grow"
                    :data-source="results"
                    :key-expr="keyExpr"
                    :columns="columns"
                    :allow-column-resizing="true"
                    :column-resizing-mode="'widget'"
                    :hover-state-enabled="true"
                    :selection_mode="'single'"
                    @row-dbl-click="onRowDblClick"
                >
                    <DxSelection mode="single" />
                </dx-data-grid>
            </div>
        </div>
        <div v-if="!resultsVisible" class="ai-background-image-home" />
    </div>
</template>

<script>
export default {
    name: 'ai-home-component',
};
</script>
<script setup>
import { ref, computed, reactive, onMounted } from 'vue';
import { DxDataGrid, DxSelection } from 'devextreme-vue/data-grid';
import { getDataSource } from '@/service/meta-service';
import AiSearchForm from '@/components/ai-home/ai-search-form.vue';
import { getDefaultContextGroup, saveContexts, ContextNames } from '@/layouts/main-layout/main-layout-data';
import { showLoadPanel, hideLoadPanel } from '@/components/utils/ai-global-load-panel.js';
// import AiGridRo from '@/components/ai-grid-ro/ai-grid-ro.vue';

const resultsVisible = ref(null);
const gridRef = ref();
const keyExpr = ref('id');

const columns = computed(() => {
    // return state.dataColumns;
    if (state.dataColumns) {
        const columns = state.dataColumns;
        columns.forEach(column => {
            column.visible = column.pos > 0;
        });
        return columns;
    } else {
        return [];
    }
});

const results = computed(() => state.dataSource ?? []);

const state = reactive({
    dataSource: [],
    dataColumns: [],
});

defineProps({
    meta: {
        type: Object,
        default: () => {
            return {
                searchInput: [],
            };
        },
    },
});

const searchInfo = {};

onMounted(() => {
    // console.log('ai-home-component.mount');
});

const onSearch = async e => {
    searchInfo.cond = e;
    await requestData(e);
    resultsVisible.value = true;
};

const onSearchStart = e => {
    resultsVisible.value = true;
};
const onSearchEnd = e => {
    resultsVisible.value = false;
};

const requestData = async e => {
    showLoadPanel();
    try {
        const url = 'core./search/get';
        const args = e;
        const answer = await getDataSource(url, args);
        if (answer.result) {
            if (answer.data) {
                state.dataSource = answer.result ? answer.data.rows : [];
                state.dataColumns = answer.result ? answer.data.meta : [];
                keyExpr.value = state.dataColumns.length > 0 ? state.dataColumns[0].dataField : 'id';
            } else {
                state.dataSource = [];
                state.dataColumns = [];
            }
        } else {
            if (answer.errors) {
                hideLoadPanel();
                throw new Error(answer.errors.map(e => e.message).join('\n'));
            } else {
                state.dataSource = [];
                state.dataColumns = [];
            }
        }
    } finally {
        hideLoadPanel();
    }
    console.log('end requestData');
};

const setContext = async dataRow => {
    const orgContextGroup = getDefaultContextGroup(ContextNames.ORG_CONTEXT_GROUP);

    if (searchInfo.cond.what === 'abn') {
        orgContextGroup.contexts.PayerContext = { value: dataRow['abn_id'], userText: dataRow['abn_name'] };
    }

    if (searchInfo.cond.what === 'dog') {
        orgContextGroup.contexts.PayerContext = { value: dataRow['abn_id'], userText: dataRow['abn_name'] };
        orgContextGroup.contexts.DogContext = { value: dataRow['dog_id'], userText: dataRow['dog_num'] };
    }

    if (searchInfo.cond.what === 'obj') {
        orgContextGroup.contexts.PayerContext = { value: dataRow['abn_id'], userText: dataRow['abn_name'] };
        orgContextGroup.contexts.DogContext = { value: dataRow['dog_id'], userText: dataRow['dog_num'] };
        orgContextGroup.contexts.NumObjContext = { value: dataRow['obj_id'], userText: dataRow['obj_num'] };
    }

    if (searchInfo.cond.what === 'pnt') {
        orgContextGroup.contexts.PayerContext = { value: dataRow['abn_id'], userText: dataRow['abn_name'] };
        orgContextGroup.contexts.DogContext = { value: dataRow['dog_id'], userText: dataRow['dog_num'] };
        orgContextGroup.contexts.NumObjContext = { value: dataRow['obj_id'], userText: dataRow['obj_num'] };
        orgContextGroup.contexts.PointContext = { value: dataRow['pnt_id'], userText: dataRow['pnt_num'] };
    }

    await saveContexts({ nameGroup: ContextNames.ORG_CONTEXT_GROUP, value: orgContextGroup });
};

const onRowDblClick = e => {
    setContext(e.data);
};
</script>

<style scoped lang="scss">
.cards {
    max-width: 960px;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    flex-wrap: wrap;
}

#ai-home-start {
    color: #387070;
    display: flex;
    flex-direction: column;
    width: calc(100% - 80px);
    height: 100%;
    margin: 20px;
    .ai-search-panel-container {
        width: 100%;
        height: 100%;

        display: flex;
        flex-direction: row;
        justify-content: center;
        padding-top: 5px;

        .ai-search-panel {
            width: 100%;
            height: 100%;
        }
    }

    .ai-background-image-home {
        width: 100%;
        height: 100%;
        background-image: url('@/assets/login-background.jpeg');
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
        border-radius: 20px;
    }

    #ai-home-start-widget-container {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: start;
        align-content: center;

        #ai-widget-row {
            display: flex;
            align-items: flex-start;
            flex-wrap: nowrap;
            height: 100%;
            column-gap: 15px;

            // amavrin
            // padding: 20px 0 30px 0;
            padding: 16px 16px 16px 20px;
            margin-bottom: 24px;
            border-radius: 10px;
            background-color: var(--light-blue);
            // box-shadow: 0 2px 4px rgba(0, 0, 0, .1);
        }

        @media (max-width: 768px) {
            #ai-widget-row {
                display: block;
            }
        }
    }
}
</style>
